import React, { useState } from "react";
import classes from "./subjectFormModal.module.css";
// @ts-ignore
import mergeClassNames from "merge-class-names";
import LoadingButton from "../../../components/LoadingButton";
import {
  useGradeFileTypeSelector,
  useSubjectFormDataSelector,
} from "../../../redux/selector";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import {
  addSemesterStateSubject,
  deleteSemesterStateSubject,
  hideSubjectFormData,
  updateSemesterStateSubject,
} from "../../../redux/slices/gradeFileSlide";
import { Subject } from "../../../models/subject";
import { unwrapResult } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Formik } from "formik";
import CustomInput from "../../../components/CustomInput";
import ReactModal from "react-modal";
import Modal from "react-modal";

const validationSchema = Yup.object().shape({
  mappingId: Yup.string()
    .matches(/^[A-Za-z0-9, ]*$/)
    .label("mã môn học"),
  name: Yup.string().required().label("tên môn học"),
  credit: Yup.number().integer().min(0).required().label("số tín chỉ"),
});

Modal.setAppElement("#root");

function SubjectFormModal() {
  const [submitFetching, setSubmitFetching] = useState(false);
  const [deleteFetching, setDeleteFetching] = useState(false);
  const { visible, mode, subject, semesterId } = useSubjectFormDataSelector();
  const dispatch = useDispatch<AppDispatch>();
  const gradeFileType = useGradeFileTypeSelector();

  function handleSubmit({
    mappingId,
    name,
    credit,
  }: {
    mappingId: string;
    name: string;
    credit: string;
  }) {
    setSubmitFetching(true);
    const mappingIdList = mappingId
      .split(",")
      .map((s) => s.trim())
      .filter((s) => !!s);
    console.log(mappingIdList);
    const newSubjectInfo: Subject =
      mode === "edit"
        ? ({
            ...subject,
            mappingId: mappingIdList,
            name,
            credit: Number.parseInt(credit),
          } as any)
        : ({
            mappingId: mappingIdList,
            name,
            credit: Number.parseInt(credit),
          } as any);
    dispatch(
      mode === "edit"
        ? updateSemesterStateSubject({
            semesterId,
            subject: newSubjectInfo,
          })
        : addSemesterStateSubject({
            semesterId,
            subject: newSubjectInfo,
          })
    )
      .then(unwrapResult)
      .then(() => {
        toast.info(
          `${mode === "edit" ? "Cập nhật" : "Thêm"} môn học thành công`
        );
      })
      .catch((err) => {
        console.error(err);
        toast.info(
          `${mode === "edit" ? "Cập nhật" : "Thêm"} môn học không thành công`
        );
      })
      .finally(() => {
        setSubmitFetching(false);
      });
  }

  function handleDelete() {
    const res = window.confirm(
      "Bạn có chăc chắn muốn xóa môn học? Hành động này không thể hoàn tác"
    );
    if (res) {
      setDeleteFetching(true);
      dispatch(
        deleteSemesterStateSubject({
          semesterId,
          subject: subject as Subject,
        })
      )
        .then(unwrapResult)
        .then(() => {
          toast.info("Xóa môn học thành công");
        })
        .catch((err) => {
          console.error(err);
          toast.error("Xóa môn học không thành công");
        })
        .finally(() => {
          setDeleteFetching(false);
        });
    }
  }

  function closeSubjectFormPopup() {
    dispatch(hideSubjectFormData());
  }

  function handleCancel() {
    closeSubjectFormPopup();
  }

  return (
    <ReactModal
      isOpen={visible}
      onRequestClose={handleCancel}
      shouldCloseOnOverlayClick={true}
      style={{
        content: {
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          padding: 0,
          width: "1000px",
          maxWidth: "95vw",
          height: "var(--modal-height)",
          maxHeight: "80vh",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          zIndex: 1000,
        },
      }}
    >
      <div
        className={mergeClassNames(
          classes.root,
          mode === "edit" ? classes.isEdit : classes.isAdd
        )}
      >
        <h2 className={classes.heading}>
          {mode === "edit" ? "Chỉnh sửa môn học" : "Thêm môn học mới"}
        </h2>
        <div className={classes.formContainer}>
          <Formik
            initialValues={{
              mappingId:
                mode === "edit" && subject && subject.mappingId
                  ? subject.mappingId?.join(",")
                  : "",
              name: mode === "edit" && subject ? subject.name : "",
              credit:
                mode === "edit" && subject && subject.credit !== null
                  ? "" + subject.credit
                  : "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit }) => (
              <>
                <div className={classes.inputContainer}>
                  {gradeFileType === "firestore" ? (
                    <CustomInput
                      fieldLabel="Mã môn học"
                      fieldName="mappingId"
                      placeholder="Mã môn học"
                    />
                  ) : null}
                  <CustomInput
                    fieldLabel="Tên môn học"
                    fieldName="name"
                    placeholder="Tên môn học"
                  />
                  <CustomInput
                    fieldLabel="Số tín chỉ"
                    fieldName="credit"
                    placeholder="Số tín chỉ"
                    type={"number"}
                  />
                </div>
                <div className={classes.buttonContainer}>
                  <LoadingButton
                    fetching={submitFetching}
                    className={classes.importButton}
                    onClick={handleSubmit}
                  >
                    {mode === "create" ? `Thêm` : `Cập nhật`}
                  </LoadingButton>
                  {mode === "edit" ? (
                    <LoadingButton
                      className={classes.cancelButton}
                      onClick={handleDelete}
                      fetching={deleteFetching}
                    >
                      Xoá
                    </LoadingButton>
                  ) : null}
                  <LoadingButton
                    className={classes.cancelButton}
                    onClick={handleCancel}
                  >
                    Huỷ
                  </LoadingButton>
                </div>
              </>
            )}
          </Formik>
        </div>
      </div>
    </ReactModal>
  );
}

export default SubjectFormModal;
